export default "__VITE_ASSET__CpoXvMRM__"